var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import TermsOfServiceSection from '@marketing/components/sections/non_product/TermsOfService/TermsOfService';
import { Helmet } from 'react-helmet-async';
var TOS = function () {
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsx("link", { rel: "canonical", href: "https://nomnomnow.com/tos" }) }), _jsx("div", __assign({ className: "header-lining bg-surface-beige" }, { children: _jsx(TermsOfServiceSection, {}) }))] }));
};
export default TOS;
